// extracted by mini-css-extract-plugin
export default {"verificationForm":"axnui-theming-verification-form__verification-form__NArBa"};